import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateComp from "@/components/public/DateComp";
export default {
  name: "ServeCountForLink",
  components: {
    DateComp: DateComp
  },
  props: ["queryRang"],
  data: function data() {
    return {
      loading: false,
      selectList: [],
      selected: "",
      searchText: "",
      chartType: "dbfwsl",
      grid: {
        left: "20px",
        right: "20px",
        top: 60,
        bottom: 10,
        show: true,
        containLabel: true
      },
      // yAxis: [
      //   {
      //     type: "value",
      //     name: "办理数(个)",
      //     minInterval: 1
      //   },
      //   {
      //     type: "value",
      //     name: "时长(h)",
      //     splitLine: {
      //       show: false
      //     },
      //     axisLabel: {
      //       formatter: "{value} h"
      //     }
      //   }
      // ],
      // legend: {
      //   data: ["待办服务数量", "环节响应时长"]
      // },
      list: []
    };
  },
  created: function created() {},
  computed: {
    legend: function legend() {
      if (this.chartType == "dbfwsl") {
        return {
          data: ["待办服务数量"]
        };
      }

      return {
        data: ["环节响应时长"]
      };
    },
    yAxis: function yAxis() {
      if (this.chartType == "dbfwsl") {
        return {
          type: "value",
          name: "办理数(个)",
          minInterval: 1
        };
      }

      return {
        type: "value",
        name: "时长(h)",
        axisLabel: {
          formatter: "{value} h"
        }
      };
    },
    xAxis: function xAxis() {
      if (this.list.length) {
        return {
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: 15
          },
          data: this.list.map(function (val) {
            return val.lingName;
          }),
          axisPointer: {
            type: "shadow"
          }
        };
      }

      return null;
    },
    series: function series() {
      if (this.list.length) {
        if (this.chartType == "dbfwsl") {
          return {
            type: "bar",
            name: "待办服务数量",
            barMaxWidth: "40px",
            itemStyle: {
              color: "#67C23A"
            },
            data: this.list.map(function (val) {
              return val.taskNum;
            })
          };
        }

        return {
          type: "bar",
          name: "环节响应时长",
          barMaxWidth: "40px",
          itemStyle: {
            color: "#409EFF"
          },
          data: this.list.map(function (val) {
            return (val.costTime / 3600000).toFixed(2);
          })
        };
      }

      return null;
    }
  },
  mounted: function mounted() {
    this.fetchSelectList();
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      var date = this.$refs.date.getValue();
      this.$http.post("serveCount/linkRanking", JSON.stringify({
        startDate: date[0],
        endDate: date[1],
        queryRang: this.queryRang,
        processDefId: this.selected.id
      }), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    fetchSelectList: function fetchSelectList() {
      var _this2 = this;

      this.loading = true;
      this.$http.post("serve/query", this.$qs.stringify()).then(function (_ref2) {
        var data = _ref2.data;

        if (data.RetCode) {
          var arr = [];

          var _iterator = _createForOfIteratorHelper(data.RetData),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              var _iterator2 = _createForOfIteratorHelper(item.serveList),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var val = _step2.value;

                  if (val.serveType == 1) {
                    arr.push({
                      id: val.id,
                      label: val.serveName
                    });
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _this2.selectList = arr;
          _this2.selected = arr[0];

          _this2.$nextTick(function () {
            _this2.fetchList();
          });
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var selectList = this.selectList;
      var results = queryString ? selectList.filter(this.createFilter(queryString)) : selectList;
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    changeSelect: function changeSelect(item) {
      var _this3 = this;

      this.searchText = item.label;
      this.$nextTick(function () {
        _this3.fetchList();
      });
    },
    searchTextSelect: function searchTextSelect(item) {
      var _this4 = this;

      this.selected = item;
      this.$nextTick(function () {
        _this4.fetchList();
      });
    }
  }
};